


















































































































































import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class EditLink extends Vue {
  public brandId = 0
  public linkId: string = ''
  public loading = true
  public busy = false
  public form = {
    link_type: '',
    title: '',
    description: '',
    website_link: '',
    ios_link: '',
    android_link: ''
  }
  public croppers: any[] = new Array(4)
  public linkImages: any[] = new Array(4)
  public imageNames: any[] = ['', '', '', '']
  public initialImages: any[] = new Array(4)

  get appInstallLinkError (): string {
    if (this.form.link_type !== 'app-install') return ''
    const ios = (this.form.ios_link || '').trim()
    const android = (this.form.android_link || '').trim()
    if (!ios && !android) return 'Please enter at least one of iOS or Android link.'
    return ''
  }

  getLink () {
    this.loading = true
    this.$store.dispatch('getLink', { brandId: this.brandId, linkId: this.linkId }).then((response: any) => {
      const body = response.body || {}
      const link = body.data || body
      this.form = {
        link_type: link.link_type || '',
        title: link.title || '',
        description: link.description || '',
        website_link: link.website_link || '',
        ios_link: link.ios_link || '',
        android_link: link.android_link || ''
      }
      const images = link.images || link.link_images || []
      for (let i = 0; i < 4; i++) {
        if (images[i]) {
          Vue.set(this.initialImages, i, images[i].image || images[i].url)
          this.imageNames[i] = images[i].description || ''
        }
      }
      this.loading = false
    }, () => {
      this.loading = false
      this.$notify({ type: 'error', text: 'Failed to load link' })
      this.$router.push('/brand/links')
    })
  }

  generateImage (index: number) {
    if (!this.croppers[index] || !this.croppers[index].hasImage()) return
    const url = this.croppers[index].generateDataUrl()
    if (url) Vue.set(this.linkImages, index, url)
  }

  saveLink () {
    if (this.form.link_type === 'app-install' && this.appInstallLinkError) {
      this.$notify({ text: this.appInstallLinkError, type: 'error' })
      return
    }
    for (let i = 0; i < 4; i++) this.generateImage(i)
    this.$validator.validateAll('edit-link-form').then((result) => {
      if (!result) {
        this.$notify({ text: 'Please fix the errors below.', type: 'error' })
        return
      }
      if (this.busy) return
      const linkType = (this.form.link_type || '').trim()
      const title = (this.form.title || '').trim()
      const images: any[] = []
      this.linkImages.forEach((dataUrl, index) => {
        if (dataUrl && dataUrl.length > 0) {
          images.push({ image: dataUrl, description: (this.imageNames[index] || '').trim() })
        }
      })
      this.busy = true
      const updateData = {
        link_type: linkType,
        title,
        description: (this.form.description || '').trim(),
        website_link: linkType === 'watch' || linkType === 'review' ? (this.form.website_link || '').trim() : '',
        ios_link: linkType === 'app-install' ? (this.form.ios_link || '').trim() : '',
        android_link: linkType === 'app-install' ? (this.form.android_link || '').trim() : ''
      }
      this.$store.dispatch('updateLink', { brandId: this.brandId, linkId: this.linkId, data: updateData }).then(() => {
        if (images.length > 0) {
          this.$store.dispatch('uploadLinkImages', {
            brandId: this.brandId,
            linkId: this.linkId,
            images
          }).then(() => {
            this.$notify({ text: 'Link and images updated successfully', type: 'success' })
            this.busy = false
            this.$router.push('/brand/links')
          }, () => {
            this.$notify({ text: 'Link updated but image upload failed', type: 'error' })
            this.busy = false
          })
        } else {
          this.$notify({ text: 'Link updated successfully', type: 'success' })
          this.busy = false
          this.$router.push('/brand/links')
        }
      }, () => {
        this.busy = false
        this.$notify({ type: 'error', text: 'Failed to update link' })
      })
    })
  }

  created () {
    this.brandId = this.$store.state.userData.brandId
    this.linkId = this.$route.params.linkId
    this.getLink()
  }
}
